import { render, staticRenderFns } from "./MultiUserInput.vue?vue&type=template&id=f6a461c8&scoped=true"
import script from "./MultiUserInput.vue?vue&type=script&lang=js"
export * from "./MultiUserInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a461c8",
  null
  
)

export default component.exports